// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
export var CouponCycle;
(function (CouponCycle) {
    CouponCycle[CouponCycle["OneMonth"] = 0] = "OneMonth";
    CouponCycle[CouponCycle["ThreeMonth"] = 1] = "ThreeMonth";
    CouponCycle[CouponCycle["SixMonth"] = 2] = "SixMonth";
    CouponCycle[CouponCycle["Year"] = 3] = "Year";
    CouponCycle[CouponCycle["Zero"] = 4] = "Zero";
})(CouponCycle || (CouponCycle = {}));
